import Dexie from 'dexie';

export const dexie = new Dexie('boox-users');//数据库名称
dexie.version(1).stores({
  users: '&++id, dbId, name, user, lastMessage, unRead, createdAt, updatedAt', // Primary key and indexed props 对象仓库（objectStore）：friends，唯一的id作为键路径（key path）
});
